import React from 'react'
import Dropzone from 'react-dropzone'
import classnames from 'classnames'
import { Line } from 'rc-progress'
import { includes } from 'lodash'

import { MessageErrorInput } from 'Components/Message/Error/input'

import PaperClipIcon from 'Assets/Images/icons/paperClip'

import { getFilenameWithExtensionFromUrl, imageExtension } from 'Utils/Regexp'
import DropZoneUploadIcon from '../../../Assets/Images/icons/dropZoneUploadIcon'
import { useState } from 'react'

const DropzoneV2Unstyled = props => {
  const {
    accept,
    className,
    input,
    mainLabel,
    multiple = false,
    progress,
    disabled,
    onDropRejected,
    onError,
    innerRef = undefined,
    isReport = false,
    reportTypeSelected = true,
    disableClick = false,
  } = props

  const [files, setFiles] = useState([])

  const uploadIcon = (text, isReport, isFileSelect = false) => {
    const showFileIcon = isReport && isFileSelect

    return (
      <div>
        {!isReport && <DropZoneUploadIcon />}
        <div
          className={classnames({
            'dropzone-text': isReport,
            'dropzone-text-active': showFileIcon,
          })}
        >
          {showFileIcon && <PaperClipIcon />}
          <span>{text}</span>
        </div>
      </div>
    )
  }

  const renderUploadIcon = isReport => {
    const { dropzoneLabel = 'Click or move your file(s) here' } = props

    const Filepreview = ({ url, type, name = '' }) =>
      includes(type, 'image') || name.match(imageExtension) ? (
        <div
          className="file-preview"
          style={{ backgroundImage: `url(${url})` }}
        />
      ) : (
        uploadIcon(name, isReport, true)
      )

    if (!files.length && props.src) {
      return (
        <Filepreview
          url={props.src}
          name={getFilenameWithExtensionFromUrl(props.src)}
        />
      )
    }

    if (!files.length) {
      return uploadIcon(dropzoneLabel, isReport)
    }

    return files.map((file, i) => (
      <Filepreview
        key={i}
        url={file.preview}
        name={file.name}
        type={file.type}
      />
    ))
  }

  let meta = props.meta || {}
  const errorJSX =
    props.error || (meta.touched && meta.error) ? (
      <MessageErrorInput message={meta.error || props.error} />
    ) : null

  return (
    <div className={className}>
      <label cypress_id={`${props.cypress_id}-label`}>{mainLabel}</label>
      <div className="dropzone-preview">
        <Dropzone
          accept={accept ? accept : ''}
          activeClassName="dropzoneActive"
          className="dropzone"
          multiple={multiple}
          onDrop={(files, ...rest) => {
            if (!files || !files.length) {
              setFiles([])
              return
            }
            if (!isReport || reportTypeSelected) {
              setFiles(files)
            }

            input.onChange(files, ...rest)
          }}
          disabled={disabled}
          cypress_id={`${props.cypress_id}-button`}
          ref={innerRef}
          disableClick={disableClick}
          onDropRejected={
            onDropRejected
              ? () => {
                  onDropRejected()
                  setFiles([])
                }
              : undefined
          }
          onError={onError}
        />
        {renderUploadIcon(isReport)}
      </div>
      {progress && (
        <Line
          percent={progress}
          strokeWidth="1"
          strokeColor="#2db7f5"
          strokeLinecap="square"
        />
      )}
      {errorJSX}
    </div>
  )
}

export { DropzoneV2Unstyled }
